import React from 'react';
import { Switch, Tooltip } from 'antd';
import { bool, func } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons';
import './style.scss';

/**
 * IgnoreStateRow for handling ignore case of mapping profiles
 */
function IgnoreStateRow({ defaultSwitchState, onIgnoreStateChange }) {
  return (
    <div className="ignore-row">
      <Switch size="small" checked={defaultSwitchState} onChange={onIgnoreStateChange} className=".arc-color-primary" />
      <p className="arc-support arc-color-B65 arc-font-weight-400 ml12">
        Ignore this activity and do not map it to a record
      </p>
      <Tooltip title="Use this if you do not want to map this activity to any record on your database.
      e.g. if the entry belongs to friends or family of alumni who you might not want to track.
    Only the mapping is ignored. The activity will still count"
      >
        <FontAwesomeIcon className="ml8" icon={faQuestionCircle} />
      </Tooltip>
    </div>
  );
}

IgnoreStateRow.propTypes = {
  defaultSwitchState: bool,
  onIgnoreStateChange: func,
};

IgnoreStateRow.defaultProps = {
  defaultSwitchState: false,
  onIgnoreStateChange: () => {},
};

export default IgnoreStateRow;
